class GuestController {
    /*@ngInject*/
    constructor($log, $timeout) {
        $log.debug('GuestController initialized');
        this.requestPending = false;
        this.$log = $log;
        this.$timeout = $timeout;
        this.fields = {
            email: ''
        };
    }

    init(showModal) {
        if (showModal) {
            $('#modal-guest').modal('toggle');
        }
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }

    requestSubmit(event, form) {
        if (event.keyCode === 13 && form.$valid) {
            this.$timeout(() => {
                form.$$element[0].querySelector('.js-submit').click();
            });
        }
    }
}

export default GuestController;
